import { useSelector } from 'react-redux';

import { AmountInput, Label, Switch } from '@components/index';
import { GROUP_MEMBER_MAX_AMOUNT } from '@constants/generic';
import { FormDataType } from '@types';

interface CustomAmountSectionProps {
  formData: FormDataType;
  onCustomAmountEnabledChange: (enabled: boolean) => void;
  onCustomMinAmountChange: (value: string) => void;
}

const CustomAmountSection = ({
  formData,
  onCustomAmountEnabledChange,
  onCustomMinAmountChange
}: CustomAmountSectionProps) => {
  const { orgConfig } = useSelector((state: any) => state.user);
  const groupMemberMaxAmount =
    orgConfig?.group_member_amount_max || GROUP_MEMBER_MAX_AMOUNT;

  return (
    <div>
      <div className="flex items-start gap-2">
        <Switch
          handleClick={onCustomAmountEnabledChange}
          value={!!formData.isCustomAmountEnabled}
        />
        <div className="min-w-0 flex-1 pb-1">
          <span className="text-base font-semibold text-cofeeNeutral10">
            Enable custom amount
          </span>
          <div className="text-sm text-cofeeNeutral7">
            Payers can choose to enter a custom amount on the review page during
            payment.
          </div>
          {formData.isCustomAmountEnabled && (
            <div className="mt-4 w-full md:w-1/2">
              <Label
                label="Enter minimum amount"
                className="!mb-2 !text-content"
                isRequired
              />
              <AmountInput
                value={formData.customMinAmount || ''}
                onAmountChange={onCustomMinAmountChange}
                className="!w-1/2 !bg-white"
                maxAmount={groupMemberMaxAmount.toString()}
                allowDecimals
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAmountSection;
